// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1sn2A","label":"Category_label__3YWkP","content":"Category_content__LlQyO","header":"Category_header__1YXzI","location":"Category_location__CpwED"};